export default __webpack_public_path__ + "static/media/twitter_purple.4c030bcc.svg";